import { forgotPasswordActionTypes } from '../actions/forgot-password-action-types';




const initialState = {
    status: "Forgot Password",
    passwordRequestComplete: false,
    passwordRequestError: false
   
};

export const forgotPassword = (state = initialState, action) => {


    switch (action.type) {

        case forgotPasswordActionTypes.FORGOT_REQUEST:
        return { forgotPassword: true };
    case forgotPasswordActionTypes.FORGOT_RECEIVED:
        return {
            ...state, 
            status:"Reset your Password",
            passwordRequestComplete: true
        };
    case forgotPasswordActionTypes.FORGOT_REQUEST_FAILED:
        return {
            ...state,
            passwordRequestError: true
        };
    default:
        return state;

    }

};








// WEBPACK FOOTER //
// ./src/signup/reducers/forgot-password-reducer.js